export const BroadcastMode = {
    Sync: 'BROADCAST_MODE_SYNC',
    Async: 'BROADCAST_MODE_ASYNC',
    Block: 'BROADCAST_MODE_BLOCK',
};
export const BroadcastModeKeplr = {
    Sync: 'sync',
    Async: 'async',
    Block: 'block',
};
